export function api(suffix){
    return process.env.VUE_APP_BACKEND_ROOT + suffix
}